import { BASE_URL } from "../config/api";

export function getFullPath(pathValue?: string | null): string | null {
  if (!pathValue) return null;

  const trimmedPath = pathValue.trim();
  if (!trimmedPath) return null;

  // Normalize Windows-style separators from API/storage payloads.
  const slashedPath = trimmedPath.replace(/\\+/g, "/");

  if (
    slashedPath.startsWith("http://") ||
    slashedPath.startsWith("https://") ||
    slashedPath.startsWith("data:") ||
    slashedPath.startsWith("blob:")
  ) {
    const fullPath = slashedPath;
    console.log("[getFullPath] resolved fullPath:", fullPath);
    return fullPath;
  }

  // Handle host-like values without a scheme, e.g. marriagetestingapi.../uploads/...
  if (/^[a-z0-9.-]+\.[a-z]{2,}\/.*$/i.test(slashedPath)) {
    const fullPath = `https://${slashedPath}`;
    console.log("[getFullPath] resolved fullPath:", fullPath);
    return fullPath;
  }

  // Keep Vite static assets untouched.
  if (slashedPath.startsWith("/assets/")) {
    const fullPath = slashedPath;
    console.log("[getFullPath] resolved fullPath:", fullPath);
    return fullPath;
  }

  const baseUrl = BASE_URL.replace(/\/api\/?$/, "").replace(/\/+$/, "");
  let normalizedPath = slashedPath.startsWith("/")
    ? slashedPath.substring(1)
    : slashedPath;

  // If payload includes intermediate segments before uploads, keep only uploads/... onward.
  const uploadsIndex = normalizedPath.toLowerCase().indexOf("uploads/");
  if (uploadsIndex > 0) {
    normalizedPath = normalizedPath.substring(uploadsIndex);
  }

  const fullPath = normalizedPath.toLowerCase().startsWith("uploads/")
    ? `${baseUrl}/${normalizedPath}`
    : `${baseUrl}/uploads/${normalizedPath}`;

  console.log("[getFullPath] resolved fullPath:", fullPath);
  return fullPath;
}
